import React, { useState } from 'react';
import { UiGrid } from '@open-stack/ui';
import { TipForm } from '../../../components/tip/form/TipForm';
import { SpcCheckoutHeader } from '../header/SpcCheckoutHeader';

interface Props {
    totalCost: number;
    presets: number[];
    isLoading: boolean;

    onNext(tipAmount: number): any;
    onClose(): void;
}

export function SpcCheckoutChooseTip({ totalCost, presets, isLoading, onNext, onClose }: Props) {
    const [tipAmount, setTipAmount] = useState<any>();

    return (
        <UiGrid>
            <SpcCheckoutHeader totalCost={totalCost + (tipAmount || 0)} onClose={onClose} />

            <TipForm
                tipAmount={tipAmount}
                onChangeTipAmount={setTipAmount}
                totalCostInitial={totalCost}
                tipPresets={presets}
                onContinue={() => onNext(tipAmount)}
                isLoading={isLoading}
            />
        </UiGrid>
    );
}
